<template>
  <div id="app">
    <router-view name="header"></router-view>
    <router-view name="default"></router-view>
<!--    <router-view name="default" v-if="isRouterAlive"></router-view>-->
    <router-view name="footer"></router-view>
    <div class="spe-wrap" v-if="showQuan"></div>
    <transition name="fade">
      <div class="quan-wrap" v-if="showQuan">
        <div class="quan-bottom">
          <div class="use-btn" @click="closeQuan">知道了</div>
        </div>
        <div class="quan-top">
<!--          <div class="close-quan-btn" @click="closeQuan"></div>-->
          <div class="tit"></div>
          <div class="cont">
            <div class="num-dw">
              <span class="num">{{coupon.price}}</span>
              <span class="dw">元</span>
            </div>
            <div class="fw">适用范围: {{coupon.scopeTypeStr}}</div>
<!--            <div class="fw">-->
<!--              <div class="tt">适用范围:</div>-->
<!--              <div class="itm">上古神话专辑</div>-->
<!--              <div class="itm">合集1(1~30集)</div>-->
<!--            </div>-->
            <div class="yxq">有效日期:{{coupon.endTimeStr}}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script >
//import "./utils/tongji.js"
import global_ from '@/api/global'

export default {
  name: 'app',
  components: {

  },
  provide(){
    return{
      // reload:this.reload
      //privateTj:this.privateTj
    }
  },
  data () {
    return {
      isRouterAlive:true,
      showQuan: false,
      coupon:{},
      // pageFilter: false
    }
  },
  // watch: {
  //   '$route': {
  //     immediate: true,
  //     handler () {
  //       // console.log('1111111111111111111111111111')
  //       if (this.$route.name === 'index') {
  //         this.pageFilter = true
  //       }
  //     }
  //   }
  // },
  beforeMount () {
    window.addEventListener('resize', this.resizeHandler)
  },
  mounted () {
    this.resizeHandler();
    this.getAvailableCouponList();
  },
  methods: {
    //获取优惠券
    getAvailableCouponList(){
      let that = this;
      that.showQuan = false;
      let url="/rrbi/coupon/availableCouponList/0?ti="+new Date().getMilliseconds();
      that.$axios.get(url).then(function(result){
        console.log("availableCouponList",result.data.response)
        console.log("result.data.code",result.data.code)
        if(result.data.code==0){
          return ;
        }
        console.log("result.data.response.list.length",result.data.response.list.length)
        if(result.data.response.list.length>0){
          that.coupon = result.data.response.list[0];
          console.log("that.coupon",that.coupon)
          that.coupon.scopeTypeStr = '';
          // 1为所有剧集包；2为所有合集；3为所有专辑
          if(that.coupon.scopeType === 1){
            that.coupon.scopeTypeStr = '所有剧集包'
          }
          if(that.coupon.scopeType === 2){
            that.coupon.scopeTypeStr = '所有合集'
          }
          if(that.coupon.scopeType === 3){
            that.coupon.scopeTypeStr = '所有专辑'
          }
          if(that.coupon.scopeType === 4){//自定义
            // let scope = that.coupon.scopeInfo.Json
            let scope=JSON.parse(that.coupon.scopeInfo);
            let scopeName = ''
            scope.forEach(function (e){
              scopeName += e.collectionName+",";
            })
            that.coupon.scopeTypeStr = scopeName
          }
          console.log(that.coupon.scopeTypeStr)
          console.log(that.coupon)
          that.showQuan = true;
        }else{
          that.showQuan = false;
        }

      })
    },
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      })
    },
    // privateTj(){
    //
    //   console.log("pv统计==========================================")
    //
    //   setTimeout(()=>{
    //     (function() {
    //           //每次执行前，先移除上次插入的代码
    //           document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
    //           let hm = document.createElement("script");
    //           hm.src = "https://hm.baidu.com/hm.js?4ec2612aaa9d9c49159ce2fe00144ed0";
    //           hm.id = "baidu_tj"
    //           let s = document.getElementsByTagName("script")[0];
    //           s.parentNode.insertBefore(hm, s);
    //
    //           window._hmt.push(['_trackPageview', window.location.pathname])
    //       })();
    //   },0);
    // },
    isMobile () {
      const WIDTH = 1024 // 低于这个宽度将会展现移动端布局
      const deviceWidth = document.body.getBoundingClientRect().width
      return deviceWidth <= WIDTH
    },
    resizeHandler () {
      if(this.isMobile()) {
        this.$store.dispatch('SetDevice', 'mobile')
      } else {
        this.$store.dispatch('SetDevice', 'desktop')
      }
    },
    closeQuan () {
      let that = this;
      let url="/rrbi/coupon/receiveAllCoupon/0?ti="+new Date().getMilliseconds();
      that.$axios.get(url).then(function(result){

      })
      that.showQuan = false

    }
  }
}
</script>

<!--<style lang="scss">-->
<!--#app {-->
<!--font-family: "Avenir", Helvetica, Arial, sans-serif;-->
<!-- -webkit-font-smoothing: antialiased;-->
<!-- -moz-osx-font-smoothing: grayscale;-->
<!--text-align: center;-->
<!--color: #2c3e50;-->
<!--}-->
<!--#nav {-->
<!--padding: 30px;-->
<!--a {-->
<!--font-weight: bold;-->
<!--color: #2c3e50;-->
<!--&.router-link-exact-active {-->
<!--color: #42b983;-->
<!--}-->
<!--}-->
<!--}-->
<!--</style>-->

<style>
@import "../static/css/reset.css";
#app {
  overflow-x: hidden;
}
</style>

<style scoped lang="less">
@import "./assets/less/quan.less";
.page-filter {
  filter: grayscale(1)
}
</style>
